import { Dispatch, SetStateAction } from "react";
import Modal from "../Shared/Modal";
import CloseIcon from "../Icons/CloseIcon";

type ModalProps = {
    isOpen: boolean;
    closeModal: Dispatch<SetStateAction<boolean>>;
    file: string;
};

const IFrameModal = ({ isOpen, closeModal, file }: ModalProps) => {
    return (
        <Modal
            className={"!max-w-[1246px]"}
            isOpen={isOpen}
            closeModal={closeModal}
        >
            <div className="py-4 px-2 relative">
                <button
                    onClick={() => {
                        closeModal(false);
                    }}
                    className="absolute top-3 right-4 md:right-9"
                >
                    <CloseIcon />
                </button>
                <div className="w-full h-full min-h-[500px] mt-4 relative z-50 overflow-y-auto max-h-[700px]">
                    <object data={file} type="application/pdf" className="mt-5" width="100%" height="500px">
                        <p>Your web browser doesn't have a PDF plugin.
                            Instead you can <a className="font-bold text-primary"               href={file}
              download={file}
>click here to
                                download the PDF file.</a></p>
                    </object>
                </div>
            </div>
        </Modal>
    );
};

export default IFrameModal;
